const paymentModeTransformer = response => {
  return response.map(e => ({ key: e.key, label: e.name, value: e.name, id: e.id }))
}

export default paymentModeTransformer
